import { type IconProps } from '../iconProps';

export const Logout: React.FC<IconProps> = ({
  size = 24,
  fill = 'none',
}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='lucide lucide-log-out-icon lucide-log-out'
    >
      <path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4' />
      <polyline points='16 17 21 12 16 7' />
      <line
        x1='21'
        x2='9'
        y1='12'
        y2='12'
      />
    </svg>
  );
};
